export default "#### Awesome, we can deliver!\n\nYou could have your car delivered in 3-5 days\n";